import * as actions from 'actions/PaymentActions/PaymentActions';
import { AsyncStatus } from 'utils/asyncStatusHelper';
import * as constants from 'pages/PaymentsPage/PaymentOptions/constants';
import { get } from 'lodash';
export const INITIAL_STATE = {
    asyncStatus: AsyncStatus.INIT,
    upi_apps: []
};
export default function upiOptions(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actions.UPI_OPTIONS_REQUEST:
            return Object.assign({}, state, { asyncStatus: AsyncStatus.LOADING });
        case actions.UPI_OPTIONS_ERROR:
            return Object.assign({}, state, Object.assign({ asyncStatus: AsyncStatus.ERROR }, action.error));
        case actions.UPI_OPTIONS_SUCCESS:
            return Object.assign({}, state, Object.assign({ asyncStatus: AsyncStatus.SUCCESS }, action.data));
        case actions.INSTRUMENT_CHECK_SUCCESS: {
            if (action.requestData.upi_details) {
                const upiApps = state.upi_apps.map(option => updateUPIPaymentAdjustments(action, option));
                return Object.assign(Object.assign({}, state), { upi_apps: upiApps });
            }
            return state;
        }
        default:
            return state;
    }
}
function updateUPIPaymentAdjustments(action, option) {
    const paymentInstrument = get(action, ['data', 'bin_check', 'card_type']);
    // update offers for UPI collect on UPI ID verification
    if (option.payment_instrument === constants.PAYMENT_INSTRUMENT.UPI_COLLECT &&
        paymentInstrument === constants.PAYMENT_INSTRUMENT.UPI_COLLECT) {
        return Object.assign(Object.assign({}, option), { adjustments: get(action, ['data', 'adjustments']) });
    }
    return option;
}
